const fireKeyEvent = (el, evtType, key, keyCode) => {
    const doc = el.ownerDocument;
    const win = doc.defaultView || doc.parentWindow;
    let evtObj;
    if (doc.createEvent){
        if (win.KeyEvent || win.KeyboardEvent) {
            evtObj = doc.createEvent('KeyboardEvent');
            Object.defineProperties(evtObj, {
                key: {value: key},
                keyCode: {value: keyCode},
                which: {value: keyCode}
            });
            evtObj.initKeyboardEvent(evtType, true, true, win, 0, 0);
        } else {
            evtObj = doc.createEvent('UIEvents');
            Object.defineProperty(evtObj, 'key', {
                get: function () {
                    return key;
                }
            });
            Object.defineProperty(evtObj, 'keyCode', {
                get: function () {
                    return keyCode;
                }
            });
            Object.defineProperty(evtObj, 'which', {
                get: function () {
                    return keyCode;
                }
            });
            evtObj.initUIEvent(evtType, true, true, win, 1);
        }
        el.dispatchEvent(evtObj);
    } else if (doc.createEventObject){
        evtObj = doc.createEventObject();
        evtObj.keyCode = keyCode;
        el.fireEvent(`on${evtType}`, evtObj);
    }
    return evtObj;
};

export default fireKeyEvent;
